import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import MyReqsList from "../../containers/myReqsList/myReqsList.container";
import AlllReqsList from "../../containers/allReqsList/allReqsList.container";

import ToggleTabs from "../../containerSmall/toggleTabs/toggleTabs.component";
import {
  selectAllReqsIsLoading,
  selectMyReqsIsLoading,
  selectReqsActiveTab,
} from "../../redux/reqs/reqs.selectors";
import { setReqsTab } from "../../redux/reqs/reqs.actions";

// import WithSpinner from "../../HOC/withSpinner/WithSpinner.component";

// const MyReqsListWithSpinner = WithSpinner(MyReqsList);
// const AlllReqsListWithSpinner = WithSpinner(AlllReqsList);

const AlllReqs = ({
  selectReqsActiveTab,
  setReqsTab,
  // selectMyReqsIsLoading,
  // selectAllReqsIsLoading,
}) => {
  // console.log(selectReqsActiveTab === 0);
  return (
    <div>
      <ToggleTabs getTab={selectReqsActiveTab} setTab={setReqsTab}>
        <button data-n={0}>بارهای من</button>
        <button data-n={1}>همه درخواست‌ها</button>
      </ToggleTabs>
      <div className="h-100 py-4">
        {Number(selectReqsActiveTab) === 0 ? <MyReqsList /> : <AlllReqsList />}
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectReqsActiveTab: selectReqsActiveTab,
  selectAllReqsIsLoading: selectAllReqsIsLoading,
  selectMyReqsIsLoading: selectMyReqsIsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  setReqsTab: (active) => dispatch(setReqsTab(active)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlllReqs);
